import { render, staticRenderFns } from "./LoadTransfer.vue?vue&type=template&id=6df30b2d&"
import script from "./LoadTransfer.vue?vue&type=script&lang=js&"
export * from "./LoadTransfer.vue?vue&type=script&lang=js&"
import style0 from "./LoadTransfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports